import { reactive } from "@vue/composition-api";
import { AutocompleteResult } from "@/components/Autocomplete/autocomplete-id";

import { LineItem } from "@/store/modules/lineItems";

interface hasLineItemId {
  lineItemId: string;
}

export const enum LineItemStatus {
  active = "active",
  archived = "archived",
}

const prettifiedLineItemStatus = {
  active: "Active",
  archived: "Archived",
};

export const prettifyLineItemStatus = (s: LineItemStatus) => {
  return prettifiedLineItemStatus[s];
};

export const lineItemStatusReverseLookup = <{ [key: string]: LineItemStatus }>{
  active: LineItemStatus.active,
  archived: LineItemStatus.archived,
};

export const enum LineItemCategory {
  work_order_task = "work_order_task",
  truck_load = "truck_load",
}

const prettifiedLineItemCategory = {
  work_order_task: "Work Order Task",
  truck_load: "Truck Load",
};

export const prettifyLineItemCategory = (s: LineItemCategory) => {
  return prettifiedLineItemCategory[s];
};

export const lineItemCategoryReverseLookup = <
  { [key: string]: LineItemCategory }
>{
  work_order_task: LineItemCategory.work_order_task,
  truck_load: LineItemCategory.truck_load,
};

export interface FormLineItem {
  id: string;
  description: string;
  default_rate: number | string;
  status: string;
  category: string;
}

export function buildFormLineItem() {
  const formLineItem = reactive<FormLineItem>({
    id: "",
    description: "",
    default_rate: 0,
    status: LineItemStatus.active,
    category: LineItemCategory.work_order_task,
  });

  const loadLineItemIntoForm = (lt: LineItem, flu: FormLineItem) => {
    flu.id = lt.id;
    flu.description = lt.description;
    flu.default_rate = lt.default_rate;
    flu.status = lt.status;
    flu.category = lt.category;
  };

  const lineItemCategories = reactive<LineItemCategory[]>([]);

  const lineItemStatuses = reactive<LineItemStatus[]>([]);

  const loadLineItemCategoriesIntoForm = (ltCategories: LineItemCategory[]) => {
    ltCategories.push(
      LineItemCategory.work_order_task,
      LineItemCategory.truck_load,
    );
  };

  const loadLineItemStatusesIntoForm = (ltStatuses: LineItemStatus[]) => {
    ltStatuses.push(LineItemStatus.active, LineItemStatus.archived);
  };

  return {
    formLineItem,
    loadLineItemIntoForm,
    lineItemStatuses,
    loadLineItemStatusesIntoForm,
    lineItemCategories,
    loadLineItemCategoriesIntoForm,
  };
}

export function buildFormLineItemAutocomplete() {
  let formLineItem = () => {
    return reactive<AutocompleteResult>({
      id: "",
      label: "",
    });
  };

  let updateLineItem = (
    evt: AutocompleteResult,
    formLineItem: AutocompleteResult,
    formData: hasLineItemId,
  ) => {
    formLineItem.id = evt.id;
    formLineItem.label = evt.label;
    formData.lineItemId = evt.id;
  };

  return {
    formLineItem,
    updateLineItem,
  };
}
